import { currentFilterViewKey } from "./types";

export const removeCurrentView = (pageKey: string) => {
    const currentView = localStorage.getItem(currentFilterViewKey) || '{}';
    const parsedCurrentView = JSON.parse(currentView);
    delete parsedCurrentView[pageKey];
    localStorage.setItem(currentFilterViewKey, JSON.stringify(parsedCurrentView));
}